import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { bgGradient } from '@/app/theme/css';
import InViewAnimationComponent from '../in-view-animation-container';

export default function DeviceManageLayout({ children, title, description }) {
  const theme = useTheme();

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      <Stack
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
        sx={{
          ...bgGradient({
            color: alpha(
              theme.palette.background.default,
              theme.palette.mode === 'light' ? 0.75 : 0.7
            ),
            imgUrl: '/assets/background/overlay_5.jpg',
          }),
          height: 350,
          position: 'absolute',
          inset: 0,
        }}
      >
        <InViewAnimationComponent>
          <Stack gap={2}>
            <Typography variant="h2" sx={{ textAlign: 'center' }}>
              {title}
            </Typography>
            <Typography variant="h5" sx={{ textAlign: 'center', maxWidth: 600 }}>
              {description}
            </Typography>
          </Stack>
        </InViewAnimationComponent>
      </Stack>
      <Stack flexGrow={1} sx={{ zIndex: 10, marginTop: '350px' }}>
        {children}
      </Stack>
    </Stack>
  );
}
